var Backbone, SupportMerchantContactTemplate, SupportMerchantContactView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMerchantContactTemplate = require('../../../../merchant_contact_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportMerchantContactView = (function(superClass) {
  extend(SupportMerchantContactView, superClass);

  function SupportMerchantContactView() {
    return SupportMerchantContactView.__super__.constructor.apply(this, arguments);
  }

  SupportMerchantContactView.prototype.events = {
    'click .show-email-form': 'showEmailForm'
  };

  SupportMerchantContactView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportMerchantContactTemplate;
    return this.mainView = this.options.mainView;
  };

  SupportMerchantContactView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportMerchantContactView.prototype.toHash = function() {
    return {
      merchantName: "Sample Merchant name",
      merchantEmail: "sample_merchant@email.com",
      merchantPhone: "800-123-45678"
    };
  };

  SupportMerchantContactView.prototype.showEmailForm = function() {
    return this.mainView.showPriorityView(this.mainView.emailFormMainView, true);
  };

  return SupportMerchantContactView;

})(Backbone.View);

module.exports = SupportMerchantContactView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY29tbW9uL3ZpZXdzL21lcmNoYW50X2NvbnRhY3Rfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9jb21tb24vdmlld3MvbWVyY2hhbnRfY29udGFjdF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLG9FQUFBO0VBQUE7OztBQUFBLDhCQUFBLEdBQWlDLE9BQUEsQ0FBUSxpREFBUjs7QUFDakMsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7dUNBRUosTUFBQSxHQUNFO0lBQUEsd0JBQUEsRUFBMkIsZUFBM0I7Ozt1Q0FFRixVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7SUFDdEIsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7V0FDWixJQUFDLENBQUEsUUFBRCxHQUFZLElBQUMsQ0FBQSxPQUFPLENBQUM7RUFKWDs7dUNBTVosTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBVjtFQURNOzt1Q0FHUixNQUFBLEdBQVEsU0FBQTtXQUNOO01BQ0UsWUFBQSxFQUFjLHNCQURoQjtNQUVFLGFBQUEsRUFBZSwyQkFGakI7TUFHRSxhQUFBLEVBQWUsZUFIakI7O0VBRE07O3VDQU9SLGFBQUEsR0FBZSxTQUFBO1dBQ2IsSUFBQyxDQUFBLFFBQVEsQ0FBQyxnQkFBVixDQUEyQixJQUFDLENBQUEsUUFBUSxDQUFDLGlCQUFyQyxFQUF3RCxJQUF4RDtFQURhOzs7O0dBckJ3QixRQUFRLENBQUM7O0FBd0JsRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
